import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ts',
    fullName: 'Tsonga',
    nativeName: 'Tsonga',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid ya xirhendzevutani",
    landing_title: "Xin’wana xo Hlamarisa Xi Ta",
    landing_subtitle: "ArgVoid i studio xa nhluvukiso wa app na mintlangu. Tshama u langutile, swilo leswintshwa swi ta ku nga ri khale!",
    select_language: "Hlawula Ririmi",
    search_placeholder: "Ku lavisisa tindzimi...",
    terms_title: "Mimpimanyeto ya Ntirho",
    policy_title: "Pholisi ya Vuhlayiseki bya Swihundla",
    cookies_title: "Pholisi ya Tikhukhi",
    terms_content: `
        <strong>1. Ku amukeriwa ka Mimpimanyeto</strong><br>
        Hi ku nghena eka ArgVoid, Mimpimanyeto leyi ya Vukorhokeri ya amukeriwa. Loko swipimelo leswi swi nga pfumelelani, vukorhokeri a byi fanelanga ku tirhisiwa.<br><br>

        <strong>2. Matirhiselo ya Pulatifomo</strong><br>
        ArgVoid na switirhisiwa swa yona swi nyikiwa "hilaha swi nga hakona" hi swikongomelo swa vuxokoxoko na vutumbuluxi. Vukorhokeri byi fanele ku tirhisiwa ntsena eka swikongomelo swa le nawini.<br><br>

        <strong>3. Mahanyelo lama yirisiweke</strong><br>
        Ku tirhisa vuhlayiseki bya sayiti, ku rhumela swipamu, kumbe ku ringeta ku nghena hi ndlela leyi nga pfumeleriwangiki eka switirhisiwa swi yirisiwile swinene.<br><br>

        <strong>4. Ku tiyimelela</strong><br>
        Pulatifomo na vukorhokeri swi nga cinciwa nkarhi wihi na wihi handle ka xitiviso. Ku hava waranti leyi nyikiwaka mayelana na nkarhi wo tirha kumbe ku kumeka ka vukorhokeri.
    `,
    policy_content: `
        <strong>1. Nhlengeleto wa Mahungu</strong><br>
        Pulatifomo a yi lavi ku tiyisisiwa ka mutirhisi kumbe ku tumbuluxiwa ka akhawunti eka nkarhi lowu. Ku hava vuxokoxoko byo tivisa munhu (ku fana na mavito kumbe tiadirese ta imeyili) lebyi hlengeletiwaka hi xihatla eka vaendzi.<br><br>

        <strong>2. Data ya Matirhiselo</strong><br>
        Vuxopaxopi bya xisekelo, lebyi nga tiviwiki byi nga hlengeletiwa ku twisisa thrafikhi ya sayiti na ku antswisa switirhisiwa. Data leyi a yi hlanganisiwanga na vutivi bya mutirhisi un’wana na un’wana.<br><br>

        <strong>3. Vukorhokeri bya Vanhu va Vunharhu</strong><br>
        Vaphakeri va vanhu va vunharhu va nga tirhisiwa eka vukorhokeri bya vuhlayiselo na vuxopaxopi. Maendlelo ya vuhlayiseki bya vaphakeri lava hi ku hambana ya lawula datha leyi nga tiviwiki leyi tirhisiwaka eka switirhisiwa swa vona.<br><br>

        <strong>4. Vuhlayiseki bya Data</strong><br>
        Ku tirhisiwa magoza lama ringaneleke ya vuhlayiseki ku sirhelela pulatifomo. Hambiswiritano, ku hava ndlela yo hundzisela eka Internet leyi sirhelelekeke hi ku helela.<br><br>
    `,
    cookies_content: `
        <strong>1. Xana Tikhukhi na Vuhlayiselo bya Ndhawu i yini?</strong><br>
        Tikhukhi na vuhlayiselo bya laha kaya bya browser i tifayela letitsongo ta datha leti hlayisiweke eka xitirhisiwa ku tsundzuka swihlawulekisi swa vuhlanganisi eka maendzo hinkwawo.<br><br>

        <strong>2. Xikongomelo xa Matirhiselo</strong><br>
        Browser LocalStorage yi tirhisiwa hi ku kongoma ku hlayisa swiletelo swa vuhlanganisi, ku fana na:<br>
        - Swihlawulekisi swa ririmi<br>
        - Ku lulamisiwa ka vuhlanganisi bya mutirhisi (e.g., maendlelo kumbe swiletelo swa nhlokomhaka)<br>
        - Cache ya xitirhisiwa xa nkarhinyana<br><br>

        <strong>3. Ku hava ku Landzelerisa</strong><br>
        Tikhukhi na vuhlayiselo bya laha kaya a swi tirhisiwi ku navetisa kumbe swikongomelo swo landzelerisa swa vanhu van’wana. Data hinkwayo leyi hlayisiweke i ya ntirho wa nkoka wa pulatifomo.<br><br> hi ku kongoma

        <strong>4. Vulawuri</strong><br>
        Data ya browser yi nga susiwa nkarhi wihi na wihi hi ku tirhisa swiletelo swa browser, leswi nga ta tlhela swi veka swivumbeko swihi na swihi swa laha kaya.
    `,
    cookie_consent_text: "Hi tirhisa tikhukhi ta xisekelo ku tiyisisa leswaku webusayiti yi tirha kahle, ku fana na ku hlayisa seshini ya wena yi tirha, ku hlayisa ku tsakela ka wena ka ririmi, na swivumbeko swin’wana swa ntolovelo.",
    read_policy: "Hlaya Pholisi ya Tikhukhi",
    support_title: "Tihlanganisi na Nseketelo",
    support_subject_label: "Nhlokomhaka",
    support_message_label: "Hungu",
    support_submit_button: "Rhumela Rungula",
    support_hint: "Xiya: Leswi swi ta pfula xitirhisiwa xa wena xa imeyili xa ntolovelo ku rhumela rungula.",
    support_success_msg: "Ku pfula app ya wena ya email...",
    support_error_msg: "Ku tsandzeka ku rhumela rungula. Hi kombela u ringeta nakambe endzhaku.",
    explorer_title: "Muhloti",
    history_title: "Matimu",
    animation_title: "Swifaniso leswi hanyaka",
    config_title: "Ku lulamisiwa ka swilo",
    tool_mouse: "Hlawula (Ctrl+M) .",
    tool_brush: "Burachi (Ctrl+B) .",
    tool_brush_mode: "Mode yo Cinca (Solid/Clear) .",
    tool_eraser: "Xisula-swilo (Ctrl+E) .",
    tool_brush_size: "Lulamisa Vukulu bya Burachi",
    tool_bucket: "Ku tata (Ctrl+F) .",
    tool_eyedropper: "Xitombo xa mahlo",
    tool_grid: "Gridi (Ctrl+Ku cinca+B) .",
    tool_rotate: "Jikisa (Ctrl+Shift+R) .",
    tool_flip_h: "Flip H (Ctrl+Ku cinca+H) .",
    tool_flip_v: "Flip V (Ctrl+Ku cinca+V) .",
    tool_transpose: "Ku hundzisela (Ctrl+Shift+T) .",
    label_width: "Anama",
    label_height: "Ku leha",
    label_frames: "Nhlayo ya Tifureme",
    label_animation: "Xitayili xa Swifaniso leswi hanyaka",
    label_background_color: "Muhlovo wa le ndzhaku",
    label_interval: "Nkarhi wo wisa",
    tool_anim_config: "Ku Hlela ka Swifaniso leswi hanyaka",
    label_new_width: "Ku anama lokuntshwa",
    label_new_height: "Ku leha lokuntshwa",
    label_apply: "Endla xikombelo",
    label_colors: "Mihlovo",
    label_size: "Sayizi",
    label_tolerance: "Tiyisela",
    val_horizontal: "Ololoka",
    val_vertical: "Ololoka",
    val_sequence: "Xaxamela",
    val_bounce: "Bampa",
    val_random: "Njhe",
    val_solid: "Tiyile",
    val_clear: "Rivaleni",
    action_add_sheet: "Xiphephana Lexintshwa",
    action_import: "Xava ematikweni mambe",
    action_export: "Rhumela",
    action_sort_projects: "Hlela",
    sort_date_old: "Khale Ku Sungula",
    sort_date_new: "Lexintshwa Xo Sungula",
    sort_name_az: "Vito (A-Z) .",
    sort_name_za: "Vito (Z-A) .",
    action_new_sprite: "Sprite leyintshwa",
    action_new_project: "Phurojeke Leyintshwa",
    modal_save_all_title: "Hlayisa Ku Cinca Hinkwaswo",
    modal_save_all_desc: "Hlawula nhundzu leyi u nga ta yi hlayisa:",
    modal_save_selected: "Hlayisa Swi Hlawuriwile",
    action_saved: "Ku hlayisiwile",
    modal_create_sprite_title: "Endla Sprite Leyintshwa",
    modal_create_project_title: "Endla Phurojeke Leyintshwa",
    modal_add_sheet_title: "Engetelani Xiphephana Lexintshwa",
    modal_rename_sheet_title: "Tlhelela vito ra Xiphephana",
    modal_rename_sprite_title: "Tlhelela vito ra Sprite",
    modal_delete_sprite_title: "Susa Sprite",
    modal_delete_project_title: "Susa Phurojeke",
    modal_delete_sheet_title: "Susa Xiphephana",
    placeholder_sprite_name: "Vito",
    placeholder_project_name: "Vito",
    placeholder_sheet_name: "Vito",
    placeholder_new_name: "Vito Lerintshwa",
    action_create: "Vumba",
    action_add: "Katsa",
    action_rename: "Tlhelela vito lerintshwa",
    action_duplicate: "Ku phindha-phindha",
    action_delete: "Sula",
    action_cancel: "Khansela",
    confirm_delete_sprite: "Xana u tiyisile leswaku u lava ku susa sprite leyi?",
    confirm_delete_project: "Xana wa tiyiseka leswaku u lava ku susa phurojeke leyi? Ti sprite hinkwato ti ta susiwa.",
    confirm_delete_sheet: "Xana wa tiyiseka leswaku u lava ku susa phepha leri?",
    err_select_sprite: "Hi kombela u hlawula sprite ku sungula.",
    err_select_project: "Hi kombela u rhanga hi ku hlawula phurojeke.",
    err_name_empty: "Vito a ri nge vi na nchumu.",
    err_sprite_exists: "Sprite leyi nga na vito rero se yi kona.",
    err_project_exists: "Phurojeke leyi nga na vito rero se yi kona.",
    err_no_content: "Ku hava nhundzu yo hlayisa.",
    err_no_changes: "Ku hava ku cinca loku faneleke ku hlayisiwa.",
    err_delete_last_sheet: "A swi nge swi koti ku susa phepha ro hetelela.",
    err_extract_frames: "A nga swi kotanga ku humesa tifureme tihi na tihi.",
    err_indexeddb: "Ku tsandzekile ku hlayisa laha kaya. Xihlamusela-marito xa wena xi nga ha va xi nga seketeli IndexedDB.",
    msg_upload_success: "Ku layicha Ku Humelerile: {0}",
    msg_upload_failed: "Ku layicha swi tsandzekile: {0}",
    msg_save_success: "Hlayisa ku humelela.",
    msg_saving: "Ku hlayisa...",
    msg_multi_save_result: "Nhundzu leyi hlayisiweke {0}. {1} ku tsandzeka.",
    menu_title: "Menyu",
    menu_save: "Hlayisa",
    menu_save_all: "Hlayisa Hinkwaswo",
    menu_support: "Tihlanganisi na Nseketelo",
    label_local_storage: "Vuhlayiselo bya Ndhawu",
    label_sign_in: "Nghena eka",
    modal_export_title: "Ku rhumela ehandle Sprite",
    label_filename: "Vito ra fayili",
    label_format: "Xivumbeko xa xirhendzevutani",
    action_export_confirm: "Rhumela",
};

export default translations;
